import React from 'react';
import { Box, LinearProgress } from '@material-ui/core';

import useStyles from './styles';
import Logo from '../../../components/Logo';

const CheckingAuth = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Logo className="logo" />
      <LinearProgress className="loading-bar" />
    </Box>
  );
};
export default CheckingAuth;
